import { Controller } from "./Controller";
var MfunsPosDanmaku = /** @class */ (function () {
    function MfunsPosDanmaku(config) {
        var _this = this;
        this.controller = new Controller({
            stageSize: config.stageSize || [1920, 1080],
            container: config.container
        });
        this.getDanmaku = config.getDanmaku || (function () { return []; });
        // 添加弹幕
        if (config.getDanmaku) {
            this.controller.loadDanmaku(this.getDanmaku());
        }
        // 监听大小变化
        window.addEventListener("resize", function () {
            _this.controller.stage.resize();
        });
    }
    /**
     * 播放
     */
    MfunsPosDanmaku.prototype.play = function () {
        this.controller.play();
    };
    /**
     * 暂停
     */
    MfunsPosDanmaku.prototype.pause = function () {
        this.controller.pause();
    };
    /**
     * 跳转
     */
    MfunsPosDanmaku.prototype.seek = function (time) {
        this.controller.seek(time);
    };
    /**
     * 当前时间
     * @returns number
     */
    MfunsPosDanmaku.prototype.time = function () {
        return this.controller.getTime();
    };
    /**
     * 重置弹幕舞台尺寸
     */
    MfunsPosDanmaku.prototype.resize = function () {
        this.controller.stage.resize();
    };
    /**
     * 重新加载弹幕
     */
    MfunsPosDanmaku.prototype.reload = function () {
        this.controller.clearDanmaku(); // 清空弹幕
        this.controller.loadDanmaku(this.getDanmaku()); // 加载弹幕
        this.controller.refresh(); // 刷新
    };
    /**
     * 重置引擎
     */
    MfunsPosDanmaku.prototype.reset = function () {
        this.controller.reset(); // 清空重置
        this.controller.loadDanmaku(this.getDanmaku()); // 加载弹幕
        this.controller.refresh(); // 刷新
    };
    /**
     * 添加一条弹幕
     */
    MfunsPosDanmaku.prototype.addDanmaku = function (d) {
        this.controller.addDanmaku(d);
    };
    /**
     * 播放一条弹幕(不添加到时间轴)
     */
    MfunsPosDanmaku.prototype.playDanmaku = function (d) {
        this.controller.playDanmaku(d);
    };
    return MfunsPosDanmaku;
}());
export { MfunsPosDanmaku };
// 添加进全局
if (typeof globalThis !== "undefined") {
    globalThis.MfunsPosDanmaku = MfunsPosDanmaku;
}
else {
    window["MfunsPosDanmaku"] = MfunsPosDanmaku;
}
//# sourceMappingURL=index.js.map